import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=5465345d&scoped=true&"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js&"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=5465345d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465345d",
  null
  
)

export default component.exports